(function() {
	'use strict';

	angular
		.module('iqxCore')
		.controller('JobSearchAdvancedCtrl', JobSearchAdvancedCtrl)


	function JobSearchAdvancedCtrl ($scope, $location, JobSearchSvc) {

        if ($scope.userHasRight('CANDHIDEJOBSPAGE')) {
            $location.url('/noPermission')
            return
        }
      
        if (JobSearchSvc.searchValues && JobSearchSvc.searchValues.$text && !JobSearchSvc.searchValues.jobtype){
        JobSearchSvc.searchValues=angular.copy(JobSearchSvc.LastSearchValues) || {} // Previous search was a simple text search - forget that and use stashed previous full search if available
        }
        $scope.searchValues = JobSearchSvc.searchValues  // Link to the service object
        $scope.theParams=[]
    
        $scope.executeQuery=function(){   // Executed by the 'Search Jobs' button
            $scope.isSubmitted=true
            if (!$scope.theForm.$valid) {return}
        JobSearchSvc.LastSearchValues=angular.copy($scope.searchValues)  // Stash for reuse
        JobSearchSvc.searchInit()  // Force a new search (as opposed to using existing results)
        $location.url('/jobsearch/results')
        }
    
        JobSearchSvc.getSearchFields()
            .then(function(){
                $scope.theParams=JobSearchSvc.searchFields
            })
      
    }

})()